<template>
<div class="panel">
    <div class="row columns">
        <div class="panel-title big-title">
            Rapport de Dungeon Bowl
        </div>
        <template v-if="current" v-for="tr in teamReportList">
          <hr>
          <div class="panel-content">
            <div class="large-12 columns" >
              <DBTeamReportViewer :tr="tr"></DBTeamReportViewer>
            </div>
          </div>
        </template>
        <div v-else>
            <spinner></spinner>
        </div>
      <hr>
    </div>
    <commentPanel :entity_type="mrContentType.id" :entity_id="id"></commentPanel>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import playerReportViewer from './player-report-viewer.vue'
import commentPanel from '../common/comment-panel.vue'
import mrDetailedHeader from './mr-detailed-header.vue'
import starReportViewer from './star-report-viewer.vue'
import DBTeamReportViewer from './db-team-report-viewer.vue'

export default {
  name: 'mrDBDetail',
  components: {
    spinner,
    playerReportViewer,
    commentPanel,
    mrDetailedHeader,
    starReportViewer,
    DBTeamReportViewer
  },
  props: {
    'id': null
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      current: 'detailedMatchReport'
    }),
    ...mapGetters([
      'teamReportList'
    ]),
    mrContentType: function () {
      return store.getters.getContent('league_manager', 'matchreport')
    }

  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('activateFullSizePage')
    store.dispatch('getContentType')
    store.dispatch('getDetailedMatchReport', this.id.toString())
    this.$store.dispatch('getTeamReportListForMatch', this.id)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
</style>



// WEBPACK FOOTER //
// mr-db-detail.vue?e1d37126